window.slate = window.slate || {};
window.theme = window.theme || {};
slate.a11y = {
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';
    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },
  focusHash: function() {
    var hash = window.location.hash;
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },
  trapFocus: function(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';
    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }
    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();
    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },
  removeTrapFocus: function(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';
    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    $(document).off(eventName);
  }
};
slate.cart = {
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;
    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};
slate.utils = {
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },
  removeInstance: function(array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }
    return array;
  },
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];
    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};
slate.rte = {
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;
    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;
    options.$iframes.each(function() {
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      this.src = this.src;
    });
  }
};
slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:section:reorder', this._onReorder.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};
slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');
    constructor = constructor || this.constructors[type];
    if (typeof constructor === 'undefined') {
      return;
    }
    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });
    this.instances.push(instance);
  },
  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },
  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    if (!instance) {
      return;
    }
    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }
    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },
  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },
  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },
  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },
  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },
  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },
  register: function(type, constructor) {
    this.constructors[type] = constructor;
    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});
slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney
  };
})();
slate.Image = (function() {
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }
    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  function loadImage(path) {
    new Image().src = path;
  }

  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }
    if (size === 'master') {
      return this.removeProtocol(src);
    }
    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }
  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();
slate.Variants = (function() {
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }
  Variants.prototype = $.extend({}, Variants.prototype, {
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};
        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          return currentOption;
        }
      });
      currentOptions = slate.utils.compact(currentOptions);
      return currentOptions;
    },
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;
      variants.forEach(function(variant) {
        var satisfied = true;
        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });
        if (satisfied) {
          found = variant;
        }
      });
      return found || {};
    },
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      setTimeout(function() {
        var variantImage = $('[data-product-select]').find(':selected').data('variant-image');
        $('.product__images-featured li').each(function() {
          if ($(this).data('variant-url') == variantImage) {
            var slickIndex = $(this).data('slick-index');
            $('.product__images-featured ul').slick('slickGoTo', slickIndex);
          }
        });
                
        $('.product__info-sku span').text(variant.sku);
        $('.product__info-upc span').text(variant.barcode);
        //$('.actuallSkuClass').text(variant.sku);
        $('.product__info-id').text(variant.id);
        
        $('.product__info-variantid span').text(variant.id);
        if ($('.no-js option:selected').parent().data('jonard-20off')) {
          $('.product__images-banner').show();
          $('.banner__free-shipping').hide();
          $('.banner__sale').hide();
          $('.banner__new-product').hide();
          $('.banner__20offCheckoutt').show();
        } else if ($('.no-js option:selected').parent().data('map-5%')) {
          $('.product__images-banner').show();
          $('.banner__free-shipping').hide();
          $('.banner__sale').hide();
          $('.banner__new-product').hide();
          $('.banner__20offCheckoutt').show();
        } else if ($('.no-js option:selected').parent().data('map-10%')) {
          $('.product__images-banner').show();
          $('.banner__free-shipping').hide();
          $('.banner__sale').hide();
          $('.banner__new-product').hide();
          $('.banner__20offCheckoutt').show();
        } else if ($('.no-js option:selected').parent().data('map-20%')) {
          $('.product__images-banner').show();
          $('.banner__free-shipping').hide();
          $('.banner__sale').hide();
          $('.banner__new-product').hide();
          $('.banner__20offCheckoutt').show();
        } else if ($('.no-js option:selected').parent().data('free-shipping')) {
          $('.product__images-banner').show();
          $('.banner__free-shipping').show();
          $('.banner__sale').hide();
          $('.banner__new-product').hide();
          $('.banner__20offCheckoutt').hide();
        } else if ($('.no-js option:selected').data('discontinued')) {
          $('.product__images-banner').show();
          $('.banner__discontinued').show();
          $('.banner__sale').hide();
          $('.banner__new-product').hide();
          $('.banner__20offCheckoutt').hide();
        } else if ($('.no-js option:selected').data('sale')) {
          $('.product__images-banner').show();
          $('.banner__free-shipping').hide();
          $('.banner__sale').show();
          $('.banner__new-product').hide();
          $('.banner__20offCheckoutt').hide();
        } else if ($('.no-js option:selected').data('new-product')) {
          $('.product__images-banner').show();
          $('.banner__free-shipping').hide();
          $('.banner__sale').hide();
          $('.banner__new-product').show();
          $('.banner__20offCheckoutt').hide();
        } else {
          $('.product__images-banner').hide();
        }
      }, 100);
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });
      if (!variant) {
        return;
      }
      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;
      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};
      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }
      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }
      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({
        path: newurl
      }, '', newurl);
    },
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });
  return Variants;
})();
theme.swatches = (function() {
  if (!$('.swatch').length) {
    return;
  }
  var $swatchInput = $('[data-swatch-input]');
  var namespace = '.swatch';
  $swatchInput.on('change' + namespace, updateSingleOptionSelector);

  function updateSingleOptionSelector(evt) {
    var $el = $(evt.currentTarget);
    var optionIndex = $el.closest('.swatch').attr('data-option-index');
    var optionValue = $el.val();
    $el.closest('form').find('[data-single-option-selector]').eq(optionIndex).val(optionValue).trigger('change');
  }
})();
theme.handleize = function(str) {
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};
theme.attributeToString = function(attribute) {
  if (typeof attribute !== "string") {
    attribute += "";
    if (attribute === "undefined") {
      attribute = "";
    }
  }
  return jQuery.trim(attribute);
};
theme.delay = function(ms, data) {
  var deferred = jQuery.Deferred();
  setTimeout(function() {
    if (!data) {
      deferred.resolve();
    } else {
      deferred.resolve(data);
    }
  }, ms);
  return deferred.promise();
};
theme.promisify = function(value) {
  var deferred = jQuery.Deferred();
  return deferred.resolve(value).promise();
};
if ((typeof ShopifyAPI) === 'undefined') {
  ShopifyAPI = {};
}
ShopifyAPI.onCartUpdate = function(cart) {};
ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + theme.attributeToString(note),
        dataType: 'json',
        beforeSend: function() {
          $body.trigger('beforeUpdateCartNote.ajaxCart', note);
        },
        success: function(cart) {
          if ((typeof callback) === 'function') {
            callback(cart);
          } else {
            ShopifyAPI.onCartUpdate(cart);
          }
          $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
        },
        error: function(XMLHttpRequest, textStatus) {
          $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};
ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(form).serialize(),
        dataType: 'json',
        beforeSend: function(jqxhr, settings) {
          $body.trigger('beforeAddItem.ajaxCart', form);
        },
        success: function(line_item) {
          if ((typeof callback) === 'function') {
            callback(line_item, form);
          } else {
            ShopifyAPI.onItemAdded(line_item, form);
          }
          $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
        },
        error: function(XMLHttpRequest, textStatus) {
          if ((typeof errorCallback) === 'function') {
            errorCallback(XMLHttpRequest, textStatus);
          } else {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
          }
          $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.json', function(cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        beforeSend: function() {
          $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
        },
        success: function(cart) {
          if ((typeof callback) === 'function') {
            callback(cart);
          } else {
            ShopifyAPI.onCartUpdate(cart);
          }
          $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
        },
        error: function(XMLHttpRequest, textStatus) {
          $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };
    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };
    this.config = $.extend(defaults, options);
    this.position = position;
    this.$drawer = $('#' + id);
    if (!this.$drawer.length) {
      return false;
    }
    this.drawerIsOpen = false;
    this.init();
  }
  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };
  Drawer.prototype.open = function(evt) {
    var externalCall = false;
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      this.$activeSource = $(evt.currentTarget);
    }
    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }
    this.$drawer.prepareTransition();
    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }
    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }
    this.bindEvents();
    return this;
  };
  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      return;
    }
    $(document.activeElement).trigger('blur');
    this.$drawer.prepareTransition();
    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
    this.drawerIsOpen = false;
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });
    this.unbindEvents();
  };
  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }, this));
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });
    this.nodes.$page.on('click.drawer', $.proxy(function() {
      this.close();
      return false;
    }, this));
  };
  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };
  return Drawer;
})();
var ajaxCart = (function(module, $) {
  'use strict';
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  function init(options) {
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '${{amount}}',
      disableAjaxCart: false,
      enableQtySelectors: true
    };
    $.extend(settings, options);
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);
    $body = $(document.body);
    isUpdating = false;
    if (settings.enableQtySelectors) {
      _qtySelectors();
    }
    if (!settings.disableAjaxCart && $addToCart.length) {
      _formOverride();
    }
    _adjustCart();
  }

  function loadCart() {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  function _updateCountPrice(cart) {
    console.log(cart)
    if ($cartCountSelector) {
      $cartCountSelector.html('(' + cart.item_count + ')').removeClass('hidden-count');
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(slate.Currency.formatMoney(cart.total_price, settings.moneyFormat));
    }
  }

  function _formOverride() {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      $addToCart.removeClass('is-added').addClass('is-adding');
      $('.qty-error').remove();
      ShopifyAPI.addItemFromForm(evt.target, _itemAddedCallback, _itemErrorCallback);
    });
  }

  function _itemAddedCallback() {
    $addToCart.removeClass('is-adding').addClass('is-added');
    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  function _itemErrorCallback(XMLHttpRequest, textStatus) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    $addToCart.removeClass('is-adding is-added');
    if (!!data.message) {
      if (data.status === 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
        console.log(data, textStatus);
      }
    }
  }

  function _cartUpdateCallback(cart) {
    _updateCountPrice(cart);
    _buildCart(cart);
  }

  function _buildCart(cart) {
    $cartContainer.empty();
    if (cart.item_count === 0) {
      $cartContainer.append('<p>' + theme.strings.emptyCart + '</p>');
      _cartCallback(cart);
      return;
    }
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
    $.each(cart.items, function(index, cartItem) {
      if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      item = {
        key: cartItem.key,
        line: index + 1,
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: slate.Currency.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: slate.Currency.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: slate.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };
      items.push(item);
    });
    data = {
      items: items,
      note: cart.note,
      totalPrice: slate.Currency.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings + ' ' + slate.Currency.formatMoney(cart.total_discount, settings.moneyFormat),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    };
    $cartContainer.append(template(data));
    $('.ajaxcart__product-name').each(function() {
      var titleLength = 50;
      if ($(this).text().length > titleLength) {
        var productTitle = $(this).text();
        var truncateTitle = productTitle.substring(0, titleLength);
        var titleWithEllipses = truncateTitle + '...';
        $(this).text(titleWithEllipses);
      }
    });
    _cartCallback(cart);
  }

  function _cartCallback(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }

  function _adjustCart() {
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));
      var qty = _validateQty(qty);
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));
      var qty = _validateQty(qty);
      if (line) {
        updateQuantity(line, qty);
      }
    });
    $body.on('click', '.ajaxcart__delete svg', function() {
      var $el = $(this),
          line = $el.parent().data('line');
      if (line) {
        updateQuantity(line, 0);
      }
    });
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');
      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, _adjustCartCallback);
      }, 250);
    }
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  }

  function _adjustCartCallback(cart) {
    _updateCountPrice(cart);
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(_buildCart);
    }, 150);
  }

  function _qtySelectors() {
    var numInputs = $('.ajaxcart__qty input[type="number"], .product__info-quantity input[type="number"]');
    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');
        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;
        var source = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };
        $el.after(template(data)).remove();
      });
      $('.js-qty__adjust').on('click', function(e) {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));
        var qty = _validateQty(qty);
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }
        $qtySelector.val(qty);
        e.stopPropagation();
      });
    }
  }

  function _validateQty(qty) {
    if ((parseFloat(qty) === parseInt(qty)) && !isNaN(qty)) {} else {
      qty = 1;
    }
    return qty;
  }
  module = {
    init: init,
    load: loadCart
  };
  return module;
}(ajaxCart || {}, jQuery));
window.theme = window.theme || {};
theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
  onDrawerOpen: ajaxCart.load
});
ajaxCart.init({
  formSelector: '[data-product-form]',
  cartContainer: '#CartContainer',
  addToCartSelector: '[data-add-to-cart]',
  cartCountSelector: '[data-cart-count]',
  moneyFormat: theme.moneyFormat
});
jQuery(document.body).on('afterCartLoad.ajaxCart', function(evt, cart) {
  theme.CartDrawer.open();
  $(".ajaxcart__btn-first-continue").click(function(e) {
    e.preventDefault();
  })
});
theme.MobileNav = (function() {
  var selectors = {
    mobileNavDrawer: '#MobileNavDrawer'
  };
  var cache = {};

  function init() {
    cacheSelectors();
    initDrawer();
  }

  function cacheSelectors() {
    cache = {
      mobileNavDrawer: $(selectors.mobileNavDrawer)
    };
  }

  function initDrawer() {
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-left').attr('aria-controls', 'MobileNavDrawer').attr('aria-expanded', 'false');
    theme.MobileNavDrawer = new theme.Drawers('MobileNavDrawer', 'left');
  }
  return {
    init: init
  };
})();
theme.Product = (function() {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '.customPrice',
   // Quantity: '.QuantityClass',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  function Product(container) {
    this.$container = $(container);
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }
    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };
    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }
  Product.prototype = $.extend({}, Product.prototype, {
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      if (!$.isEmptyObject(variant)) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }
      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
      
   
     // $(selectors.Quantity, this.$container).html(item.quantity);
        
        
      if (variant.compare_at_price > variant.price) {
        $compareEls.removeClass('hide');
        $(selectors.comparePrice).hide();
        $(selectors.productPrice).html('<p class="product__info-price-sale"><s data-compare-price><span>Our Price &nbsp;</span>' + slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat) + '</s></p><span class="product__info-sale-text">Sale &nbsp;</span>' + slate.Currency.formatMoney(variant.price, theme.moneyFormat));
        } 
      	else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      this.$featuredImage.attr('src', sizedImgUrl);
    },
    

    
    
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });
  return Product;
})();
$(function() {
  if ($(window).width() < 768) {
    $('.footer__linklists-header').each(function() {
      $(this).on('click', function() {
        $(this).siblings('.footer__linklists-list').slideToggle();
        var icon = $(this).find('.footer__toggle');
        icon.text() == '+' ? icon.text('-') : icon.text('+');
      });
    });
  }

  function convertTelephoneNumber() {
    var telephone = $('.firefold__telephone').text();
    var newTelephone = '(' + telephone.slice(0, 3) + ') ' + telephone.slice(3, 6) + '-' + telephone.slice(6, 10);
    $('.firefold__telephone').text(newTelephone);
  }
  convertTelephoneNumber();
});
$(function() {
  $('.homepage__hero').slick({
    dots: true,
    infinite: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide Button"><img class="slick-prevImg" src="https://cdn.shopify.com/s/files/1/0020/4433/0057/files/arrow-left.svg?v=1586340892" width="30px" height="30px" alt="Previous Slide Button"></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide Button"><img class="slick-nextImg" src="https://cdn.shopify.com/s/files/1/0020/4433/0057/files/arrow-right.svg?v=1586340893" width="30px" height="30px" alt="Next Slide Button"></button>',
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [{
      breakpoint: 768,
      settings: {
        dots: false
      }
    }]
  });
});
$(function() {
  $('.shop').on('click', function() {
    $('.header__shop').toggle();
    $('.header__brands').hide();
    $('.header__customer-service').hide();
  });
  $('.brands__nav').on('click', function() {
    $('.header__brands').toggle();
    $('.header__shop').hide();
    $('.header__customer-service').hide();
  });
  $('.customer-service').on('click', function() {
    $('.header__customer-service').toggle();
    $('.header__shop').hide();
    $('.header__brands').hide();
  });
  $('.header__nav-collection').each(function() {
    $(this).hover(function() {
      $('.header__nav-submenu').hide();
      $(this).find('.header__nav-submenu').show();
    });
  });
  $(document).mouseup(function(e) {
    var container = $('.header__shop, .shop, .header__brands, .brands, .header__customer-service, .customer-service');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.header__shop').hide();
      $('.header__nav-submenu').hide();
      $('.header__brands').hide();
      $('.header__customer-service').hide();
    }
  });
  $('.tidio__chat-widget').on('click', function() {
    $('.header__customer-service').hide();
  });
  $('.mobile-nav .mobile-arrow-btn').on('click', function() {
    submenuActions($(this));
  });
  $('.mobile-nav__link').each(function() {
    var text = $(this).text();
    $(this).html(text).contents();
  });

  function submenuActions(target) {
    target.toggleClass('icon-rotate');
    target.parent().find('.mobile-nav__child-list').slideToggle();
  }

  function closeOtherSubmenus($this) {
    var inactiveSubmenus = $('.mobile-nav .mobile-arrow-btn').not($this);
    if (inactiveSubmenus.hasClass('mobile-nav__parent-active')) {
      submenuActions(inactiveSubmenus);
    }
  }
});
$(function() {
  var prevArrow = '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0020/4433/0057/files/arrow-left.svg?v=1586340892"></span>';
  var nextArrow = '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0020/4433/0057/files/arrow-right.svg?v=1586340893"></span>';
  $('.product__images-alt ul').slick({
    slidesToShow: 5,
    vertical: true,
    verticalSwiping: true,
    swiping: false,
    asNavFor: '.product__images-featured ul',
    lazyLoad: 'ondemand',
    focusOnSelect: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    centerMode: true
  });
  
  $('.product__images-featured ul').slick({
    slidesToShow: 1,
    draggable: $('.product__images-featured ul .Magic360').length  == 0,
    swipe: $('.product__images-featured ul .Magic360').length  == 0,
    asNavFor: '.product__images-alt ul',
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    lazyLoad: 'ondemand',
    fade: true
  });
  $('.related__products-cards').slick({
    slidesToShow: 4,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    lazyLoad: 'ondemand',
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  $('.product__images-featured img').each(function() {
    $(this).not('.slick-arrow img').addClass('image-zoom');
  });
  if ($(window).width() > 767) {
    $('.image-zoom').each(function() {
      $(this).parent().zoom({
        url: $(this).data('zoom'),
        magnify: 0
      });
    });
  }
  $('.content__titles').each(function() {
    $(this).on('click', function() {
      if ($(window).width() > 767) {
        $(this).addClass('content__titles-active');
        $('.content__titles').not($(this)).removeClass('content__titles-active');
        var value = $(this).data('value');
        $('.product__description-' + value).show();
        $('.product__description').not('.product__description-' + value).hide();
      } else {
        $(this).next().slideToggle();
        $(this).children().text() == '+' ? $(this).children().text('-') : $(this).children().text('+');
      }
    });
  });
  $('body').on('click', '.spr-badge-caption', function() {
    $('html, body').animate({
      scrollTop: $('.product__details-content-titles').offset().top
    }, 1250);
    $('.content__titles[data-value="reviews"]').click();
  });
  // old code for following $(".swatch-element label").click(function() {
  $(".swatch-element label").on('click touchstart', function() {
    var $parentElement = $(this).parent(".swatch-element");
    var $swatchContainer = $parentElement.parent(".swatch");
    var $element = $swatchContainer.children(".swatch-element");
    $element.each(function() {
      $(this).children("label").removeClass("variant-selected")
    })
    $(this).addClass('variant-selected');
  })
  if ($("body").hasClass("template-product")) {
    var $variantVal = $(".no-js option:selected").attr("data-variant-name");
    var $splitVal = $variantVal.split(' / ');
    var $first = $splitVal[0];
    var $second = $splitVal[1];
    $("[data-val='" + $first + "'], [data-val='" + $second + "']").trigger("click");
  }

  function checkWidth() {
    var reviews = $('#shopify-product-reviews').detach();
    if ($(window).width() < 767) {
      if ($('.product__description-reviews').children('#shopify-product-reviews')) {
        $('.product__description-reviews--placeholder').append(reviews);
      }
    } else {
      if ($('.product__description-reviews--placeholder').children('#shopify-product-reviews')) {
        $('.product__description-reviews').append(reviews);
      }
    }
  }
  checkWidth();
  $(window).resize(checkWidth);

  function sameDayShipping() {
    var today = new Date();
    var day = today.getDay();
    if (day < 6) {
      var month = today.getMonth();
      var date = today.getDate();
      var year = today.getFullYear();
      switch (month) {
        case 0:
          month = "January";
          break;
        case 1:
          month = "February";
          break;
        case 2:
          month = "March";
          break;
        case 3:
          month = "April";
          break;
        case 4:
          month = "May";
          break;
        case 5:
          month = "June";
          break;
        case 6:
          month = "July";
          break;
        case 7:
          month = "August";
          break;
        case 8:
          month = "September";
          break;
        case 9:
          month = "October";
          break;
        case 10:
          month = "November";
          break;
        case 11:
          month = "December";
          break;
      }
      var countDownTime = new Date(month + ' ' + date + ', ' + year + ' 20:00:00 GMT ').getTime();
      sameDayShippingTimer(countDownTime);
      if ($(window).width() < 768) {
        $('.product__tags').addClass('same__day-mobile');
      }
    } else {
      $('.same__day-text span').text('Orders will ship next business day.');
      $('.product__tags').removeClass('same__day-mobile');
    }
  }

  function sameDayShippingTimer(countDownTime) {
    var timer = setInterval(function() {
      var now = new Date().getTime();
      var distance = countDownTime - now;
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      $('.same__day span').html('<span>Same Day Shipping likely on orders placed in the next <span class="same__day-hour">' + (sameDayShippingNumber(hours - 0)) + '</span> hours <span class="same__day-minutes">' + (sameDayShippingNumber(minutes)) + '</span> minutes <span class="same__day-seconds">' + (sameDayShippingNumber(seconds)) + '</span> seconds.</span>');
      if (distance < 0) {
        clearInterval(timer);
        $('.same__day-text span').text('Orders will ship next business day.');
        $('.product__tags').removeClass('same__day-mobile');
      } else {
        if ($(window).width() < 768) {
          $('.product__tags').addClass('same__day-mobile');
        }
      }
    }, 1000);
  }

  function sameDayShippingNumber(value) {
    var number = value < 10 ? '0' + value : value;
    return number;
  }

  function checkDaylightSavingsTime() {
    Date.prototype.stdTimezoneOffset = function() {
      var jan = new Date(this.getFullYear(), 0, 1);
      var jul = new Date(this.getFullYear(), 6, 1);
      return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }
    Date.prototype.isDstObserved = function() {
      return this.getTimezoneOffset() < this.stdTimezoneOffset();
    }
    var today = new Date();
    var timezoneOffset;
    if (today.isDstObserved()) {
      timezoneOffset = '-04:00';
      return timezoneOffset;
    } else {
      timezoneOffset = '-05:00';
      return timezoneOffset;
    }
  }
  sameDayShipping();
});
theme.RelatedProducts = (function() {
  var selectors = {
    sectionSettingsJson: '[data-settings-json]',
    template: '#RelatedProductsTemplate-',
    relatedProductsContainer: '#RelatedProducts-'
  };

  function RelatedProducts(container) {
    this.$container = $(container);
    var sectionId = this.sectionId = this.$container.attr('data-section-id');
    var sectionSettings = JSON.parse($(selectors.sectionSettingsJson, this.$container).html());
    this.settings = sectionSettings;
    this.namespace = '.relatedProducts';
    this.$shopifySection = $('#shopify-section-' + this.sectionId);
    this.$template = $(selectors.template + sectionId, this.$container);
    this.$relatedProductsContainer = $(selectors.relatedProductsContainer + sectionId, this.$container);
    this.getProducts();
    this.freeShipping();
    this.discontinued();
    this.addToCart();
    this.addProducts();
  }
  RelatedProducts.prototype = $.extend({}, RelatedProducts.prototype, {
    getProducts: function() {
      var url = "/recommendations/products.json?product_id=" + this.settings.id + "&limit=" + this.settings.limit;
      var self = this;
      $.ajax({
        type: 'GET',
        url: url,
        dataType: 'json'
      }).done(this.getProductsSuccess.bind(this)).fail(this.getProductsError.bind(this));
    },
    freeShipping: function() {
      setTimeout(function() {
        $('.product__images-banner').each(function() {
          if ($(this).hasClass('product-card-sash')) {
            $(this).parent().parent().mouseenter(function() {
              $(this).find('.product__images-banner').show();
            });
            $(this).parent().parent().mouseleave(function() {
              $(this).find('.product__images-banner').hide();
            });
          }
        });
      }, 2000);
    },
    discontinued: function() {
      setTimeout(function() {
        $('.product__images-banner').each(function() {
          if ($(this).hasClass('product-card-sash')) {
            $(this).parent().parent().mouseenter(function() {
              $(this).find('.product__images-banner').show();
            });
            $(this).parent().parent().mouseleave(function() {
              $(this).find('.product__images-banner').hide();
            });
          }
        });
      }, 2000);
    },
    addToCart: function() {
      setTimeout(function() {
        $('.product__card').each(function() {
          $(this).mouseenter(function() {
            console.log('show-button')
            $(this).find('.product__card-form').show();
          });
          $(this).mouseleave(function() {
            $(this).find('.product__card-form').hide();
          });
        });
      }, 2000);
    },
    getProductsSuccess: function(results) {
      if (results.products.length === 0) {
        return;
      }
      var products = results.products;
      var data = {};
      var item = {};
      var items = [];
      var source = this.$template.html();
      var template = Handlebars.compile(source);
      $.each(products, function(index, product) {
        console.log(product)
        var datePublished = new Date(product.published_at).getTime() / 1000;
        var thirtyDays = datePublished + 2592000;
        var today = new Date().getTime() / 1000;
        item = {
          available: product.available,
          url: product.url,
          title: product.title,
          image: product.featured_image,
          price: slate.Currency.formatMoney(product.price),
          priceVaries: product.price_varies,
          priceMin: slate.Currency.formatMoney(product.price_min),
          priceMax: slate.Currency.formatMoney(product.price_max),
          priceSale: product.compare_at_price > product.price,
          sash: (product.tags.includes('free-shipping' || 'discontinued')) || (product.compare_at_price > product.price) || (thirtyDays > today) ? 'product-card-sash' : '',
          freeShipping: product.tags.includes('free-shipping') ? 'Free Shipping' : '',
          discontinued: product.tags.includes('discontinued') ? 'discontinued' : '',
          sale: product.compare_at_price > product.price ? 'Sale' : '',
          new: thirtyDays > today ? 'New Product' : '',
          variant_id: product.variants[0].id,
          callForQuote: product.tags.includes('callforquote') || product.tags.includes('call-for-quote') ? 'Call For Quote: (704) 979-7100' : '',
          variants: product.variants.length > 1 ? 'Select Options' : 'Add To Cart'
        };
        if (product.available == true) {
          item.available = true;
        } else {
          item.available = false;
        }
        items.push(item);
      });
      data = {
        gridItemClasses: this.settings.gridItemClasses,
        items: items
      };
      this.$shopifySection.removeClass('hide');
      this.$relatedProductsContainer.append(template(data));
    },
    getProductsError: function(jqXHR, textStatus, errorThrown) {
      console.log(textStatus + ': ' + errorThrown);
    },
    addProducts: function(e) {
      $("body").on("click", "[js-quick-add]", function(evt) {
        var $currentTarget = $(this);
        evt.preventDefault();
        addProduct($currentTarget);
      })

      function addProduct($currentTarget) {
        var $variantId = $currentTarget.attr("data-variant-id")
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: 'quantity=1&id=' + $variantId,
          id: $variantId,
          quantity: 1,
          error: function() {
            console.log("error")
          },
          success: function() {
            ajaxCart.load();
          }
        })
      }
    },
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });
  return RelatedProducts;
})();
theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');
  if (!$newAddressForm.length) {
    return;
  }
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;
    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });
  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });
  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {
        parameters: {
          _method: 'delete'
        }
      });
    }
  });
})();
theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };
  if (!$(config.recoverPasswordForm).length) {
    return;
  }
  checkUrlHash();
  resetPasswordSuccess();
  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');
    if (!$formState.length) {
      return;
    }
    $('#ResetSuccess').removeClass('hide');
  }
})();
theme.productCard = (function() {
  function productCard() {
    function productCardText() {
      setTimeout(function() {
        $('.product__card .spr-badge-caption').each(function() {
          if ($(this).text() == 'No reviews') {
            $(this).text('(0)');
          } else {
            var reviewNumber = $(this).text().replace(/[^0-9]/g, '');
            $(this).text('(' + reviewNumber + ')');
          }
        });
      }, 2500);
    }

    function freeShipping() {
      $('.product__images-banner').each(function() {
        if ($(this).hasClass('product-card-sash')) {
          $(this).parent().parent().mouseenter(function() {
            $(this).find('.product__images-banner').show();
          });
          $(this).parent().parent().mouseleave(function() {
            $(this).find('.product__images-banner').hide();
          });
        }
      });
    }
    
    function discontinued() {
      $('.product__images-banner').each(function() {
        if ($(this).hasClass('product-card-sash')) {
          $(this).parent().parent().mouseenter(function() {
            $(this).find('.product__images-banner').show();
          });
          $(this).parent().parent().mouseleave(function() {
            $(this).find('.product__images-banner').hide();
          });
        }
      });
    }

    function addToCart() {
      $('.product__card').each(function() {
        $(this).mouseenter(function() {
          $(this).find('.product__card-form').show();
        });
        $(this).mouseleave(function() {
          $(this).find('.product__card-form').hide();
        });
      });
    }
    productCardText();
    freeShipping();
    discontinued();
    addToCart();
  }
  return productCard;
})();
theme.collectionLanding = (function() {
  function collectionLanding(container) {
    $('.collection-landing__toggle').on('click', function() {
      $('.collection-landing__nav').addClass('reveal');
    });
    $('.collection-landing__close').on('click', function() {
      $('.collection-landing__nav').removeClass('reveal');
    });
  }
  return collectionLanding;
})();
theme.account = (function() {
  function createAccount() {
    $('#create_customer').submit(function(e) {
      var $this = $(this);
      var password = $('#CreatePassword').val();
      var confirmPassword = $('#ConfirmPassword').val();
      if (password == confirmPassword) {
        if (password.length >= 6) {
          $this.submit();
        } else {
          e.preventDefault();
          alert('Password must be 6 characters minimum. Please try again.');
        }
      } else {
        e.preventDefault();
        alert("Passwords must match. Please try again.");
      }
    });
  }
  return createAccount;
})();
theme.collectionPage = (function() {
  function collection() {
    function productCards() {
      $('.product__card').each(function() {
        var description = $(this).find('.product__card-description').text();
        var maxLength;
        if ($(window).width() > 767) {
          maxLength = 300;
        } else {
          maxLength = 150;
        }
        if (description.length > maxLength) {
          var trimmedDescription = description.substring(0, maxLength) + '...';
          $(this).find('.product__card-description').text(trimmedDescription);
        }
      });
      $('.collection__page-icons i').each(function() {
        $(this).on('click', function() {
          if ($(this).siblings().hasClass('list-active')) {
            $(this).siblings().removeClass('list-active');
            $(this).addClass('grid-active');
            $('.collection__list-view').removeClass('collection__list-view').addClass('collection__grid-view');
            $('.product__card-description').addClass('hide');
          }
          if ($(this).siblings().hasClass('grid-active')) {
            $(this).siblings().removeClass('grid-active');
            $(this).addClass('list-active');
            $('.collection__grid-view').removeClass('collection__grid-view').addClass('collection__list-view');
            $('.product__card-description').removeClass('hide');
          }
        });
      });
    }

    function sortCollectionOnLoad() {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
      $('#sort-by').bind('change', function() {
        Shopify.queryParams.sort_by = $(this).val();
        location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
      });
      if (window.location.search) {
        var sortValue = window.location.search.substr(9);
        $('#sort-by').val(sortValue);
      }
    }

    function powerTools() {
      $('#pt-nav-toggle p').addClass('collection__background collection__background-inactive');
      $('.filter-menu').on('click', function() {
        var background = $(this).find('.collection__background');
        if (background.hasClass('collection__background-inactive')) {
          background.addClass('collection__background-active');
          background.removeClass('collection__background-inactive');
        } else {
          background.addClass('collection__background-inactive');
          background.removeClass('collection__background-active');
        }
      });
    }

    function pagination() {
      $('.pagination a').each(function() {
        $(this).on('click', function() {
          setTimeout(function() {
            productCards();
            $('html, body').animate({
              scrollTop: $('.collection__page').offset().top - 100
            }, 500);
          }, 1000);
        });
      });
    }
    productCards();
    sortCollectionOnLoad();
    powerTools();
    pagination();
  }
  $(document).on('click', function() {
    collection();
  })
  return collection();
})();
$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register("product", theme.Product);
  sections.register("swatch", theme.swatches);
  sections.register("collection-landing", theme.collectionLanding);
  sections.register("product-card", theme.productCard);
  sections.register("account", theme.account);
  sections.register("collection-page", theme.collectionPage);
  sections.register('related-products', theme.RelatedProducts);
  slate.a11y.pageLinkFocus($(window.location.hash));
  $(".in-page-link").on("click", function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });
  var tableSelectors = ".rte table";
  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "rte__table-wrapper"
  });
  var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';
  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "rte__video-wrapper"
  });
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies");
  }
  $('.busness__form-submit').on('click', function() {
    $('html, body').animate({
      scrollTop: $('.form-success').offset().top
    }, 1000);
  });
  theme.MobileNav.init();
  if (window.location.pathname == '/cart') {
    Shopify.Cart.ShippingCalculator.show({
      submitButton: theme.strings.shippingCalcSubmitButton,
      submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
      customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
      moneyFormat: theme.strings.shippingCalcMoneyFormat
    });
  }
});


/*  Old line 323   return found || null;  */
/*  Old line 323   if (variant) {  */
